// Recovered compiled webpack factory 24437. Edit this function expression; run npm run build.
(e, t, r) => {
  function a(e) {
    let { reason: t, children: r } = e;
    return r;
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "BailoutToCSR", {
      enumerable: !0,
      get: function () {
        return a;
      },
    }),
    r(24553));
}
